export default __webpack_public_path__ + "img/schedule-send.72735506.svg";